<template>
    <v-layout row wrap>
        <v-flex>
            <v-autocomplete
                v-model="regionComputed"
                :items="rssList"
                item-text="name"
                item-value="rss"
                :outlined="outlined"
                :label="$t('appt.labels.employerRegion')"
                :color="$vuetify.theme.primary"
                :background-color="$vuetify.theme.primary"
                :placeholder="$t('appt.placeholder.employeeRegion')"
                dense
                autocomplete="password"
                class="body-2 tz-dropdown pa-0"
                @change="emitValue('')"
            />

            <v-autocomplete
                :value="value"
                :items="filteredEmployeeEstablishmentList"
                item-text="name"
                item-value="code"
                :outlined="outlined"
                :aria-label="formattedAriaLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :label="formattedLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :color="$vuetify.theme.primary"
                :background-color="$vuetify.theme.primary"
                :placeholder="placeholder"
                validate-on-blur
                :rules="[
                    !required || requiredField()
                ]"
                dense
                autocomplete="password"
                class="body-2 tz-dropdown pa-0"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @input="emitValue"
            />
        </v-flex>
    </v-layout>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { debounce, find, filter } from 'lodash';
import { ServiceSettings } from '@/enums';
import { employeeEstablishmentList, rssList } from '@/components/metadata/inputs/EmployeeEstablishment.data';

export default {
    name: 'employee-establishment',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    data() {
        return {
            region: null,
            debouncedInput: undefined,
        };
    },
    created() {
        this.rssList = rssList;
        this.region = this.regionComputed;
        this.debouncedInput = debounce(this.emitValue, 500);
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            currentEstSettings: 'services/getCurrentEstSettings',
        }),

        appendIcon() {
            return this.withIcon ? 'fas fa-id-card-alt' : '';
        },
        employeeEstablishmentList() {
            const dbData = find(this.currentEstSettings, ['setting', ServiceSettings.EMPLOYEE_ESTABLISHMENT_LIST]);
            if (dbData && dbData.length) {
                return dbData;
            }
            return employeeEstablishmentList;
        },
        filteredEmployeeEstablishmentList() {
            if (!this.region) {
                return this.employeeEstablishmentList;
            }
            return filter(this.employeeEstablishmentList, ['rss', this.region]);
        },
        regionComputed: {
            get() {
                if (this.value) {
                    const establishment = find(this.employeeEstablishmentList, ['code', this.value]);
                    return establishment.rss;
                }
                if (this.region) {
                    return this.region;
                }
                return null;
            },
            set(val) {
                this.region = val;
            },
        },
    },
    methods: {
        emitValue(value) {
            if (value !== '' || this.value) {
                this.$emit('update:value', value);
            }
        },
    },
};
</script>
